import n from '../../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".quick-input-list .quick-input-list-entry.has-actions:hover .quick-input-list-entry-action-bar .action-label.dirty-editor:before{content:\"\\ea76\"}";
n(css,{});
export { css, css as default };
